// Core lib dependencies.
import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Component dependencies.
import OverlayInterface from '../../common/Overlay/index.js';
import PrivacyPolicy from './PrivacyPolicy.jsx';

/**
 * CookiesDisabledModal React component.
 *
 * Create a non-closable overlay dialog to block access to an experience when the user has
 * all cookies disabled in their browser, making strictly-necessary cookies unavailable.
 *
 * @memberof module:PrivacyManagement.Components
 * @namespace
 *
 * @return {PrivacyManagement.Components.CookiesDisabledModal}
 */
const CookiesDisabledModal = (props) => {

  const [policyUrl, setPolicyUrl] = useState(() => {
    const configService = NGXD.getServiceContainer().getService('config');
    return configService.get('privacy.policyURL');
  });

  const handleClick = (e) => {
    window.location.reload();
  };

  if (!props.isVisible) {
    return null;
  }

  return (
    <OverlayInterface.Components.Overlay
      classes="xPrivacy_cookiesDisabledModal"
      allowUserClose={false}
    >
      <p className="xCopy info" >{NGX.lang.privacy.cookiesDisabledModal.blockedStatement}{' '}
        <PrivacyPolicy
          parameterizedText={NGX.lang.privacy.cookiesDisabledModal.policyStatement}
          linkUrl={policyUrl}
          linkTitle={NGX.lang.privacy.privacyPolicy.linkTitle}
        />
      </p>

      <p className="xCopy info">{NGX.lang.privacy.cookiesDisabledModal.refresh}</p>
      <div className="xCTAContainer">
        <button className="xButton xCTA" aria-label="refresh page" onClick={handleClick}>
          <span>Refresh</span>
        </button>
      </div>
    </OverlayInterface.Components.Overlay>
  );
};

/**
 * React PropTypes.
 *
 * @type {Object}
 * @property {Boolean} isVisible Should we show the cookies disabled modal message
 */
CookiesDisabledModal.propTypes = {
  isVisible: PropTypes.bool,
};

CookiesDisabledModal.defaultProps = {
  isVisible: false,
};

export default CookiesDisabledModal;
